import {Button, Stack, Typography} from '@mui/material';
import {AlertInfo, StyledGrid} from 'presentation/components';
import ContactPhones from 'presentation/components/ContactPhones';
import {ChatRoomsEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {BillsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useBilletDetails} from '../../hooks/useBilletDetails';

const {speakToOnlineSupport} = translations['pt-br'].commons;
const {attention, alertNegotiation, alertNegotiationNotredameSaude} =
	translations['pt-br'].privateFlow.myFinancial.billetDetails;

const NegotiationDataInfo = () => {
	const {callChatRoom} = useCallChatRoom();
	const {isNotredameSaude} = useHostName();
	const {contactPhones} = useBilletDetails();
	const currentAlertNegotiation = isNotredameSaude
		? alertNegotiationNotredameSaude
		: alertNegotiation;
	return (
		<Fragment>
			<AlertInfo.Root
				severity="error"
				data-tag-id={BillsTaggingEnum.VISUALIZOU_ALERTA_CENTRAL_BOLETO}>
				<AlertInfo.Title title={attention} />
				<AlertInfo.Description>
					<Typography fontSize={'0.875rem'}>
						{currentAlertNegotiation.line1}
						<Typography component={'span'} fontSize={'inherit'} fontWeight={700}>
							{currentAlertNegotiation.line2}
						</Typography>
					</Typography>
				</AlertInfo.Description>
			</AlertInfo.Root>
			<StyledGrid.Root>
				<StyledGrid.Item lg={6}>
					<ContactPhones copyDataTagId={BillsTaggingEnum.CLICK_COPIAR_TELEFONE_ATENDIMENTO_BOLETO} phones={contactPhones} isDetails />
				</StyledGrid.Item>
				<StyledGrid.Item lg={6}>
					<Stack height={'100%'} justifyContent={'end'}>
						<Button
							data-tag-id={BillsTaggingEnum.CLICK_FALAR_COM_ATENDIMENTO_BOLETO}
							variant="outlined"
							fullWidth
							onClick={() => callChatRoom(ChatRoomsEnum.DEBIT_NEGOTIATION)}>
							{speakToOnlineSupport}
						</Button>
					</Stack>
				</StyledGrid.Item>
			</StyledGrid.Root>
		</Fragment>
	);
};

export {NegotiationDataInfo};
